module.exports = __webpack_public_path__ + "img/achiote_menu3.b73df2a9.png";